import { IdManagementCategory } from "@/constants/idManagement";
import { z } from "zod";
import { ProxyUserTableColumns } from "./-table/type";
import { OrderDirection } from "@/constants/orderDirection";

export const ProxyUserTableFilterSchema = z.object({
  sortOrder: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z
    .enum([
      ProxyUserTableColumns.PERSON,
      ProxyUserTableColumns.LOGIN_ID,
      ProxyUserTableColumns.MATCH_TYPE,
      ProxyUserTableColumns.WORKER_TYPE,
      ProxyUserTableColumns.WORKER_CONTRACT_TYPE,
      ProxyUserTableColumns.EMPLOYMENT_TYPE,
      ProxyUserTableColumns.BOARD_MEMBER_TYPE,
      ProxyUserTableColumns.CONTRACTOR_TYPE,
      ProxyUserTableColumns.COLLABORATOR_TYPE,
    ])
    .optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),

  category: z
    .nativeEnum(IdManagementCategory)
    .default(IdManagementCategory.ALL),

  freeText: z.string().optional(),
  haveAppIdIn: z.array(z.string()).optional(),
});
